<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    title="详情"
    :visible.sync="dialogVisible"
    :before-close="notBtn"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
  >
    <el-form ref="form" size="small" label-width="140px">
      <el-form-item label="建议内容：">
        <div>{{ info }}</div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      info: ''
    }
  },
  mounted() {
    if (this.row.id) {
      this.queryDetail(this.row)
    }
  },
  methods: {
    queryDetail(row) {
      this.info = JSON.parse(JSON.stringify(row.info))
    },
    notBtn() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
.edit-dialog {
  .el-form-item__content {
    div {
      width: 240px;
    }
  }
}
</style>
